import get from 'lodash/get';
import {useDispatch,useSelector} from 'react-redux';

import {create} from '../redux/reducers/errors';
import selectError from '../redux/selectors/selectError';

const useError = () => {
  const dispatch = useDispatch();
  const error = useSelector(selectError());
  const isClosed = useSelector(store => get(store, 'errors.isClosed'));
  return {
    error,
    isClosed,
    create: err => dispatch(create({message: get(err, 'message') || ''})),
  };
};

export default useError;

